import { hydros } from "@/api";

class EquipmentList {
  constructor(funcList, filters) {
    this.funcList = funcList;
    this.filters = filters;
  }
}

const hydrometer = new EquipmentList(async () => {
  const equipments = await hydros.list()
  
  return equipments.filter(val => val.HAS_LOG_TABLE);
}, []);

export default {
  hydrometer
}